export default __webpack_public_path__ + "static/media/guesty_lite_step4.22e9e1ed.png";